/**
 * Decodes HTML entities in a string
 * @param text - The text containing HTML entities
 * @returns The decoded text
 */
export function decodeHtmlEntities(text: string): string {
    const entities: { [key: string]: string } = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#039;': "'",
        '&#x27;': "'",
        '&#x2F;': '/',
        '&nbsp;': ' ',
        '&copy;': '©',
        '&reg;': '®',
        '&trade;': '™',
        '&euro;': '€',
        '&pound;': '£',
        '&yen;': '¥',
        '&cent;': '¢',
        '&mdash;': '—',
        '&ndash;': '–',
        '&hellip;': '…',
        '&lsquo;': '\u2018',
        '&rsquo;': '\u2019',
        '&ldquo;': '\u201C',
        '&rdquo;': '\u201D',
        '&bull;': '•',
        '&middot;': '·',
        '&deg;': '°',
        '&plusmn;': '±',
        '&times;': '×',
        '&divide;': '÷',
        '&frac12;': '½',
        '&frac14;': '¼',
        '&frac34;': '¾',
        '&iexcl;': '¡',
        '&iquest;': '¿',
        '&para;': '¶',
        '&sect;': '§',
        '&dagger;': '†',
        '&Dagger;': '‡',
        '&permil;': '‰',
        '&micro;': 'µ',
        '&prime;': '′',
        '&Prime;': '″',
        '&asymp;': '≈',
        '&ne;': '≠',
        '&le;': '≤',
        '&ge;': '≥',
        '&larr;': '←',
        '&uarr;': '↑',
        '&rarr;': '→',
        '&darr;': '↓',
        '&harr;': '↔',
    }
    
    // First, decode named entities
    let decoded = text
    for (const [entity, char] of Object.entries(entities)) {
        decoded = decoded.replace(new RegExp(entity, 'g'), char)
    }
    
    // Then decode numeric entities (decimal)
    decoded = decoded.replace(/&#(\d+);/g, (_, dec) => {
        return String.fromCharCode(parseInt(dec, 10))
    })
    
    // Then decode numeric entities (hexadecimal)
    decoded = decoded.replace(/&#x([0-9A-Fa-f]+);/g, (_, hex) => {
        return String.fromCharCode(parseInt(hex, 16))
    })
    
    return decoded
}